import { render } from "./ContactSearchItem.vue?vue&type=template&id=488e2d4a&scoped=true"
import script from "./ContactSearchItem.vue?vue&type=script&lang=js"
export * from "./ContactSearchItem.vue?vue&type=script&lang=js"

import "./ContactSearchItem.vue?vue&type=style&index=0&id=488e2d4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488e2d4a"]])

export default __exports__